import React, { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import { SnackbarContent } from "@mui/material";
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, ButtonToolbar, Col, Row } from 'reactstrap';
import { showNotification, successNofication } from 'src/shared/components/Notification';
import ReactTableBase from 'src/shared/components/table/ReactTableBase';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { Checkbox } from '@mui/material';
import renderSelectField from 'src/shared/components/form/Select';
import { ERROR_MESSAGES } from "src/utils/pnd/PndConstants";

const required = value => value ? undefined : 'Required';
const VehicleHubAssingModal = ({ modalShow, setModalShow, isTitle, reactTableData }) => {

    useEffect(() => {
        GetAllActiveHub();
    }, []);

    const filteredData = reactTableData && reactTableData?.tableRowsData && reactTableData?.tableRowsData.filter(item => item.hubId === null);
    const [data, setData] = useState(filteredData);
    const [checkboxSelectAll, setSelectAll] = useState(false);
    const [selectedItem, setSelectedItem] = useState(0);
    const [isActiveHubList, setActiveHubList] = useState(null);
    const [isHideDiv, setHideDiv] = useState(false);    
    const [isHub, setHub] = useState(null);

    let Icon;
    const getHuDetails = (event) => {
        if (event) {
            setHideDiv(true);
            setHub(event.value);
        }
    };

    const tableConfig = {
        isEditable: false,
        isSortable: false,
        isResizable: false,
        withPagination: true,
        withSearchEngine: true,
        manualPageSize: [10, 50, 100, 1000],
        placeholder: 'Search by Vehicle Name ...',
    };
    const handleCheckboxClick = (event, id) => {
        event.stopPropagation();

        data[Number(id)].checkbox = !data[Number(id)].checkbox;
        setSelectAll(true);
        if (checkboxSelectAll) {
            setSelectAll(false);
        }
        setSelectedItem(
            data.filter((ele) => {
                return ele.checkbox === true;
            }).length
        );
    };

    const selectAll = () => {
        const allChecked = !checkboxSelectAll;
        const updatedData = data.map(row => ({ ...row, checkbox: allChecked }));
        setData(updatedData);
        setSelectedItem(allChecked ? updatedData.length : 0);
        setSelectAll(allChecked);
    };
    const columns = useMemo(() => [
        {
            Header: '#',
            accessor: (row, i) => i + 1, // Or just use Cell below for more control
            disableGlobalFilter: true,
            disableSortBy: true,
            width: 65,
            Cell: ({ row }) => row.index + 1, // <-- This sets the serial number based on row index
        },
        {
            id: 'select',
            Header: () => (
                <div>
                    <span>Select</span>
                    <Checkbox checked={selectedItem > 0} onClick={selectAll} />
                </div>
            ),
            accessor: 'vehicleId',
            disableSortBy: true,
            width: 15,
            Cell: ({ row }) => (
                <div>
                    <Checkbox
                        onClick={(event) => handleCheckboxClick(event, row.id)}
                        checked={row.original.checkbox}
                    />
                </div>
            )
        },
        {
            Header: 'Plate Number',
            accessor: 'plateNo',
            disableGlobalFilter: false,
        },
        {
            Header: 'Vehicle Unique ID',
            accessor: 'vehicleUniqueId',
            disableGlobalFilter: false,
        },
        {
            Header: 'Vehicle Make',
            accessor: 'makerName',
            disableGlobalFilter: false,
        },
        {
            Header: 'Vehicle Model',
            accessor: 'modelName',
            disableGlobalFilter: false,
        },
        {
            Header: 'Vehicle Type',
            accessor: 'vehicleType',
            disableGlobalFilter: false,
        },
    ], [data, selectedItem, checkboxSelectAll]);
    const toggle = () => {
        setModalShow(prevState => !prevState)
    }


    const GetAllActiveHub = async () => {
        let activeHub = [];
        try {    
            const response1 = await PndRestApi.GetAllActiveHub();
            if (response1 && response1.status === 200 && response1.data.status === 200) {
                if (response1.data.data.length > 0) {
                    response1.data.data.forEach(item => {
                        activeHub.push({ "label": item.hubName, "value": item.hubId });
                    });
                    setActiveHubList(activeHub);
                } else {
                    showNotification(
                        "theme-light",
                        "ltr",
                        `SuccessCode: ${response1?.data?.status}`,
                        `Message: Please create a Hub first`,
                    );
                }
            } else {
                console.error('Unexpected response status:', response1.status);
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response1?.data?.status}`,
                    `Message: ${response1?.data?.message}`,
                );
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            showNotification(
                "theme-light",
                "ltr",
                "Error",
                "Error fetching data",
            );
        } 
    };

    const handleSubmit = async (formValues) => {
        try {
            let obj = {};
          
            const vehicleIds = data
                .filter(row => row.checkbox) // Filter the rows based on the checkbox property
                .map(row => row.vehicleId); // Map each filtered row to its vehicleId property

            console.log(vehicleIds);
            obj["hubId"] = isHub;
            obj["vehicleId"] = vehicleIds;
            const response = await PndRestApi.AssignVehicleToHub(obj);
            if (response.status === 200 && response.data.status === 200) {
                successNofication(
                    "theme-light",
                    "ltr",
                    `SuccessCode: 200`,
                    `Message:Data Saved Successfully`,
                  );
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data.message}`,
                );
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            showNotification(
              "theme-light",
              "ltr",
              `SuccessCode: 500`,
               ERROR_MESSAGES.tryCatchError,
            );

        }
    };

    return (
        <div> {
            data ?
                <Modal
                    isOpen={modalShow}
                    toggle={toggle}
                    modalClassName={`ltr-support`}
                    className="theme-light ltr-support credit-memo-modal-form-ani">
                    <div className="modal__header">
                        <button
                            className="lnr lnr-cross modal__close-btn"
                            aria-label="modal__close-btn"
                            type="button"
                            onClick={toggle}
                        />
                        {Icon}
                        <h4
                            className="text-modal  modal__title mt-1 text-uppercase"
                            style={{ color: "#2DD2E7" }}
                        >
                            {isTitle}
                        </h4>
                    </div>
                    <ModalBody className="m-0">
                        <div className="credit-memo-modal-form-ani">
                            {/* <span className="account__logo">
                                <span
                                    className="account__logo-accent text-light"> */}

                                    <form className="form-animated" onSubmit={handleSubmit}>
                                        <Col lg={12} md={12}>
                                            <Row>
                                                <Col lg={12} md={12}>
                                                    <div className="form__form-animated-group">
                                                        <span className='required_field'>* </span><span className="form__form-animated-group-label">Hub</span>
                                                        <div className="form__form-animated-group-field">
                                                            <Field
                                                                validate={[required]}
                                                                name="hub"
                                                                component={renderSelectField}
                                                                type="text"
                                                                options={isActiveHubList}
                                                                label="Select Hub"
                                                                placeholder="Select Hub"
                                                                onChange={event => getHuDetails(event)}
                                                            />
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                            {isHideDiv &&
                                                <Row>
                                                    <Col lg={12} md={12}>
                                                        <ReactTableBase
                                                            name={"t('instution_type.view.name_map')"}
                                                            key={'searchable'}
                                                            columns={columns}
                                                            data={data}
                                                            tableConfig={tableConfig}
                                                        />
                                                    </Col>
                                                </Row>
                                            }
                                        </Col>

                                        <div className="form__OnboardingButton">
                                            <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                                                <Button color="primary" type="submit" className="next" onClick={handleSubmit}>Submit</Button>
                                            </ButtonToolbar>
                                        </div>
                                    </form>


                                {/* </span>
                            </span> */}
                        </div>
                    </ModalBody>
                </Modal> :
                <SnackbarContent message="Please Create Vehicle first" />
        }

        </div>
    );
};

VehicleHubAssingModal.propTypes = {
    VehicleHubAssingModal: PropTypes.func.isRequired,
};

const mapStateToProps = () => {
    return {}; 
};
export default connect(mapStateToProps)(reduxForm({ form: 'VehicleHubAssignmentForm', enableReinitialize: true })(VehicleHubAssingModal));